/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Promocode } from './Promocode'
import {
  PromocodeFromJSON,
  PromocodeFromJSONTyped,
  PromocodeToJSON,
} from './Promocode'

/**
 *
 * @export
 * @interface ActivePromoCode200Response
 */
export interface ActivePromoCode200Response {
  /**
   *
   * @type {boolean}
   * @memberof ActivePromoCode200Response
   */
  status: boolean
  /**
   *
   * @type {Promocode}
   * @memberof ActivePromoCode200Response
   */
  data: Promocode
}

/**
 * Check if a given object implements the ActivePromoCode200Response interface.
 */
export function instanceOfActivePromoCode200Response(
  value: object
): value is ActivePromoCode200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function ActivePromoCode200ResponseFromJSON(
  json: any
): ActivePromoCode200Response {
  return ActivePromoCode200ResponseFromJSONTyped(json, false)
}

export function ActivePromoCode200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ActivePromoCode200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: PromocodeFromJSON(json['data']),
  }
}

export function ActivePromoCode200ResponseToJSON(
  value?: ActivePromoCode200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: PromocodeToJSON(value['data']),
  }
}
